import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { MembershipPageHeader } from 'memberships/components'
import { LocatePortSection } from '../components'
import { selectors } from 'memberships/reducer'
import { selectors as memberSelectors } from 'member-reducer'
import { MembershipType } from 'types'
import { PATH, makeMembershipIdPath } from 'config'

const propTypes = {
  membership: MembershipType,
}

function LocatePort({ membership }) {
  const { sfid: membershipId } = membership

  return (
    <>
      <MembershipPageHeader
        backLinkText="Back to Boat & Home Port Information"
        backLinkTo={makeMembershipIdPath(membershipId, PATH.BOATS)}
        membership={membership}
      />
      <LocatePortSection
        previousStep={makeMembershipIdPath(
          membershipId,
          PATH.BOATS,
          PATH.HOME_PORT_ADDRESS
        )}
      />
    </>
  )
}

LocatePort.propTypes = propTypes

function mapStateToProps(state) {
  return {
    account: selectors.account(state),
    membership: memberSelectors.membership(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(LocatePort)
